$(document).ready(function () {
    if ( localStorage.getItem('sorting') && localStorage.getItem('sorting') == 'list' ) {
        $('#articles').removeClass('list-group-horizontal');
        $('#articles .item').addClass('w-100');
        $('#list').addClass('active');
        $('#list').siblings().removeClass('active');
        $('#articles .item .card').addClass('flex-lg-row');
        $('#articles .item .card .card-body').addClass('d-flex flex-column justify-content-between');
    } else if( localStorage.getItem('sorting') && localStorage.getItem('sorting') == 'grid' ) {
        $('#articles .item').removeClass('w-100');
        $('#articles').addClass('list-group-horizontal');
        $('#grid').addClass('active');
        $('#grid').siblings().removeClass('active');
        $('#articles .item .card').removeClass('flex-lg-row');
        $('#articles .item .card .card-body').removeClass('d-flex flex-column justify-content-between');
    }

    $('#list').click(function (event) {
        event.preventDefault();
        localStorage.setItem('sorting', 'list');
        $('#articles').removeClass('list-group-horizontal');
        $('#articles .item').addClass('w-100');
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
        $('#articles .item .card').addClass('flex-lg-row');
        $('#articles .item .card .card-body').addClass('d-flex flex-column justify-content-between');
    });

    $('#grid').click(function (event) { 
        event.preventDefault();
        localStorage.setItem('sorting', 'grid');
        $('#articles .item').removeClass('w-100');
        $('#articles').addClass('list-group-horizontal');
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
        $('#articles .item .card').removeClass('flex-lg-row');
        $('#articles .item .card .card-body').removeClass('d-flex flex-column justify-content-between');
    });
});